// Import the functions you need from the SDKs you need
import { initializeApp } from "firebase/app";
import { getStorage } from "firebase/storage";
// TODO: Add SDKs for Firebase products that you want to use
// https://firebase.google.com/docs/web/setup#available-libraries

// Your web app's Firebase configuration
const firebaseConfig = {
  apiKey: "AIzaSyCLaZ4aoXfUDhqKI030HGzm0H3iEl1Gv4w",
  authDomain: "omja-software-387106.firebaseapp.com",
  projectId: "omja-software-387106",
  storageBucket: "omja-software-387106.appspot.com",
  messagingSenderId: "662153111525",
  appId: "1:662153111525:web:a463a9d40b52e8af49710c"
};

// Initialize Firebase
const app = initializeApp(firebaseConfig);

// Initialize Cloud Storage and get a reference to the service
export const storage = getStorage(app);